import s from "./CTACard.module.scss";
import Image from "next/legacy/image";
import { Heading } from "@/components/UI/typography/Heading";
import { ReactNode } from "react";
import { Button } from "@/components/UI/buttons/Button";
import cn from "classnames";
import { baseUrl, WRITING_SERVICE_SUBDOMAIN } from "@/const";

export type CTACardProps = {
  heading: ReactNode;
  subheading: ReactNode;
  btnText: ReactNode;
  className?: string;
};

export const CTACard = ({ heading, subheading, btnText, className }: CTACardProps) => (
  <a href={`https://${WRITING_SERVICE_SUBDOMAIN}.${String(baseUrl)}`} className={cn(s.card, className)}>
    <div className={s.img}>
      <Image src="/img/icons/sections/icon-bulb.svg" alt="Illustration" width={60} height={60} />
    </div>
    <Heading level={3} tag={0} className={s.heading}>
      {heading}
    </Heading>
    <p className={s.subheading}>{subheading}</p>
    <Button tag="span" type="accent" className={s.button}>
      {btnText}
    </Button>
  </a>
);
